import React from "react";

const RoutineCareCell = () => {

    return (
        <div
            className="tw-flex tw-h-[114px] tw-p-3 tw-flex-col tw-justify-center tw-items-start tw-gap-2 tw-self-stretch tw-border-b tw-border-solid tw-border-mutelios-blue-light">
            <span className="tw-text-body-lead-bold tw-text-mutelios-txt-color">Soin courants</span>
            <a href="#" className="tw-underline">En savoir plus</a>
        </div>
    );
}

export default RoutineCareCell;
